<template>
  <button id="NUMBER_7" name="7" class="btn num-btn" data-vcode="NUMBER_7" aria-label="7 PQRS">
    <div class="digit">7</div>
    <div class="letters">PQRS</div>
  </button>
</template>
<script>
export default {};
</script>
